import EdListHomework from '../ed-list-homework/ed-list-homework.vue'
import EdListHomeworkSections from '../ed-list-homework-sections/ed-list-homework-sections.vue'
import EdHoweworkStudenList from '../ed-homework-student-list/ed-homework-student-list.vue'
import EdHomeworkTeacherSectionPerson from '../ed-homework-teacher-section-person/ed-homework-teacher-section-person.vue';
import Component from 'vue-class-component';
import { TEACHER_WIDGET_TASK_TABS } from '@/homework/values/homeworks.values';
import { STORE } from '@/core/store/core.store';
import { TEACHER_PORTAL_KEYS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { HOMEWORKS_EVENTS } from '@/homework/values/homeworks.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { Mixins , Prop} from 'vue-property-decorator';
import { ContainerUsersMixin } from '@/mixins/common/container-users.mixin';

@Component({
  components: {
    EdListHomework,
    EdListHomeworkSections,
    EdHoweworkStudenList,
    EdHomeworkTeacherSectionPerson
  }
})
export default class EdHomeworksContainer extends Mixins(ContainerUsersMixin) {

  @Prop({default: false}) readonly refreshSecondTab: boolean;

  public TABS = TEACHER_WIDGET_TASK_TABS;

  get tabSelected(): string {
    return this.$store.state.HomeworksStore.teacherWidgetTabSelected;
  }

  get listComponent(): string {
    return this.tabSelected == TEACHER_WIDGET_TASK_TABS.BY_STUDENT ? 'ed-list-homework' : 'ed-list-homework-sections';
  }

  get detailComponent(): string {
    return this.tabSelected == TEACHER_WIDGET_TASK_TABS.BY_STUDENT ? 'ed-homework-student-list' : 'ed-homework-teacher-section-person';
  }

  public selectTab(tab: string) {
    this.$store.commit(STORE.HOMEWORKS.MUTATIONS.SET_TEACHER_WIDGET_TAB_SELECTED, tab);
    if(this.refreshSecondTab) {
      this.dispatchReload(tab);        
    }
  }

  public getTabLocalStorage() {
    let tab = LocalStorageService.getItem(TEACHER_PORTAL_KEYS.TASKS_HOMEWORKS_TAB);
    if(tab) {
      this.selectTab(tab)
      LocalStorageService.removeItem(TEACHER_PORTAL_KEYS.TASKS_HOMEWORKS_TAB);
    }
  }

  private dispatchReload(tab: string) {
    this.$emit('secondTabRefresh');
    if(tab == this.TABS.BY_STUDENT) {
      this.$edEventBus.$emit(HOMEWORKS_EVENTS.RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET, true);
      return;
    }        
    if(tab == this.TABS.BY_SECTIONS) {
      this.$edEventBus.$emit(HOMEWORKS_EVENTS.RELOAD_TASKS_BY_SECTIONS_TAB, true);
      return;
    }
  }

  created() {
    this.getTabLocalStorage();
  }

}